<!-- 零售 - 手工签收 - 批量签收 -->
<template>
  <div class="batchArrivedOrder cus-modal" v-loading="loading">
    <Form class="formInline" :model="form" inline :label-width="90">
      <Row>
        <Col span="24">
          <FormItem :label="t('签收日期选择')+':'">
            <DatePicker type="datetime"
              :value="form.receiveDate"
              format="yyyy-MM-dd HH:mm:ss"
              @on-change="handleChange($event, 'receiveDate')"
              @on-clear="handleClear('receiveDate')"
              style="width: 200px" />
          </FormItem>
        </Col>
      </Row>
    </Form>
    <OmsButton :btn-config="btnConfig" class="modal-footer" />
  </div>
</template>

<script>
export default {
  name: 'batchArrivedOrder',
  props: {
    componentData: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        receiveDate: new Date(),
      },
      loading: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.submit();
            },
          },
        ],
      },
    };
  },
  methods: {
    handleChange(e, fieldName) {
      this.form[fieldName] = e;
    },
    handleClear(fieldName) {
      // this.form[fieldName] = '';
      this.form.receiveDate = new Date();
    },
    async submit() {
      const self = this;
      const { receiveDate } = this.form
      const arrivedDate = typeof receiveDate == 'string'
      ? receiveDate
      : $utils.getFormatDate(receiveDate, 'yyyy-MM-dd HH:mm:ss')
      const param = {
        ids: self.componentData.ids,
        arrivedDate,
      };
      const {
        data: { code, message },
      } = await this.service.common.publicUrlParams('/api/cs/oc/oms/arrived/batchArrivedOrder', param).finally(() => {
        self.$parent.$parent.closeConfirm();
      });
      if (code === 0) {
        self.$Message.success(message);
        self.$parent.$parent.$parent.getData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.formInline {
  padding-top: 1rem;
  margin-bottom: -16px;
}
</style>
